import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPagePieChart: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-pie-chart"><path d="M21.25 17C21.25 18.1736 20.7743 19.2361 20.0052 20.0052C19.2361 20.7743 18.1736 21.25 17 21.25C14.6528 21.25 12.75 19.3472 12.75 17C12.75 14.6528 14.6528 12.75 17 12.75C19.3472 12.75 21.25 14.6528 21.25 17Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.5 21.25H4.75V2.75H19.25V9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17 13V17L19.7856 19.7856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPagePieChart;
